import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Value } from '../../../../../_entity/value/index.js';
import './Renderer_NumericResult.scss';
import { exists } from '@nu-art/ts-common';
export class Renderer_NumericResult extends ComponentSync {
    static defaultProps = {
        valueModule: ModuleFE_Value
    };
    deriveStateFromProps(nextProps, state) {
        state.numericResult = nextProps.numericResult;
        state.hidden = exists(nextProps.hidden) ? nextProps.hidden : true;
        return state;
    }
    resolveSeverityValue = () => {
        if (!this.state.numericResult || !this.props.severityDeclerations)
            return { color: '#002774' };
        for (const declaration of this.props.severityDeclerations) {
            const rangeValue = this.props.valueModule.cache.unique(declaration.severityValue);
            if (!rangeValue)
                return;
            if (rangeValue.data.scope[0] <= this.state.numericResult && this.state.numericResult <= rangeValue.data.scope[1]) {
                return { label: rangeValue.data.label ?? '', color: declaration.color };
            }
        }
    };
    render() {
        return _jsx(LL_H_C, { style: { opacity: this.state.hidden ? 0 : 1 }, className: 'numeric-result', children: _jsx("div", { style: { '--numeric-result-severity': this.resolveSeverityValue()?.color ?? '#002774' }, className: 'result', children: this.state.numericResult ?? '-' }) });
    }
}
//# sourceMappingURL=Renderer_NumericResult.js.map